var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.197 3.735h-9.596c-0.641 0-1.21 0.289-1.6 0.738-0.392-0.449-0.96-0.738-1.601-0.738h-9.596c-1.178 0-2.132 0.955-2.132 2.132v18.134c0 1.178 0.955 2.133 2.132 2.133h9.596c0.010 0 0.021-0.003 0.031-0.003 0.567 0.014 1.025 0.471 1.038 1.038v1.098h1.066v-0.591h0.010v-0.481c0-0.576 0.46-1.045 1.033-1.063 0.007 0 0.016 0.003 0.023 0.003h9.596c1.178 0 2.133-0.955 2.133-2.133v-18.134c0-1.178-0.955-2.132-2.133-2.132zM3.737 24v-18.134c0-0.588 0.479-1.066 1.066-1.066h9.596c0.588 0 1.066 0.479 1.066 1.066v18.134c0 0.588-0.478 1.066-1.066 1.066h-9.596c-0.587-0-1.066-0.479-1.066-1.066zM28.263 24c0 0.588-0.478 1.066-1.066 1.066h-9.596c-0.587 0-1.066-0.479-1.066-1.066v-18.134c0-0.588 0.479-1.066 1.066-1.066h9.596c0.588 0 1.066 0.479 1.066 1.066v18.134z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.3a8253b5a44fc012e9e9251149ced824.svg";
export { ForwardRef as ReactComponent };